'use client'

import { memo } from 'react'
import {
  Calendar,
  FileText,
  Globe,
  Mail,
  Server,
  Terminal,
  TrendingUp,
  Wallet,
} from 'lucide-react'
import { cn } from '@/lib/utils'

const INTEGRATIONS = [
  { label: 'Gmail', icon: Mail },
  { label: 'Calendar', icon: Calendar },
  { label: 'Notion', icon: FileText },
  { label: 'Zerodha', icon: TrendingUp },
  { label: 'Groww', icon: TrendingUp },
  { label: 'Binance', icon: Wallet },
  { label: 'Local Shell', icon: Terminal },
  { label: 'Browser Agent', icon: Globe },
  { label: 'MCP Servers', icon: Server },
] as const

const IntegrationPill = ({ label, icon: Icon }: { label: string; icon: typeof Mail }) => (
  <div className="ninxl-integration-pill inline-flex shrink-0 items-center gap-2 rounded-full border border-slate-200 bg-white px-4 py-2 text-sm font-medium text-slate-700 shadow-sm">
    <Icon className="h-3.5 w-3.5 text-[#21728d]" />
    {label}
  </div>
)

const MarqueeRow = ({ reverse = false }: { reverse?: boolean }) => {
  // Duplicate items for seamless loop
  const items = [...INTEGRATIONS, ...INTEGRATIONS]

  return (
    <div className="ninxl-marquee-mask relative overflow-hidden py-2">
      <div
        className={cn(
          'ninxl-marquee-track flex w-max gap-3',
          reverse ? 'ninxl-marquee-reverse' : 'ninxl-marquee-forward'
        )}
      >
        {items.map((item, i) => (
          <IntegrationPill key={`${item.label}-${i}`} label={item.label} icon={item.icon} />
        ))}
      </div>
    </div>
  )
}

/** Infinite scrolling integration pills: two rows, opposite directions */
export const NinxlIntegrationMarquee = memo(function NinxlIntegrationMarquee() {
  return (
    <div className="space-y-1">
      <MarqueeRow />
      <MarqueeRow reverse />
    </div>
  )
})